import { render } from "./AltriPagamentiTypeBadge.vue?vue&type=template&id=e0025d2a"
import script from "./AltriPagamentiTypeBadge.vue?vue&type=script&lang=js"
export * from "./AltriPagamentiTypeBadge.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__